import { WEATHER_DATA_LOADED } from "./../constants/actionTypes.js";

export function weatherDataReducer(weatherData, action) {
  if (action.type === WEATHER_DATA_LOADED) {
    return action.data;
  }

  throw Error(`There is no such action ${action.type}.`);
}
